<template>
  <div class="c--shared_less-more-text less-more-text" :class="{ collapsed }">
    <p v-html="text" ref="lessMoreTextP"></p>
    <b-button variant="link" @click.prevent="lessMore" v-if="viewLessMore">
      {{ collapsed ? buttonMoreText : buttonLessText }}
    </b-button>
  </div>
</template>

<script>
  export default {
    props: {
      text: {
        type: String,
        required: true,
      },
      buttonMoreText: {
        type: String,
        required: false,
        default: 'More',
      },
      buttonLessText: {
        type: String,
        required: false,
        default: 'Less',
      },
      close: {
        type: Boolean,
        required: false,
        default: true,
      },
      isLessMorePrevent: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        collapsed: true,
        viewLessMore: true,
      }
    },
    watch: {
      close(val) {
        if (!!val && !this.collapsed) {
          this.collapsed = true
        }
      },
    },
    methods: {
      lessMore() {
        if (!this.isLessMorePrevent) {
          this.collapsed = !this.collapsed

          this.$emit('changeCollapse', this.collapsed)
        }
      },

      viewLessMoreButton() {
        let lineHeight = document.defaultView
          .getComputedStyle(this.$refs.lessMoreTextP, null)
          .getPropertyValue('line-height')

        lineHeight = parseFloat(lineHeight)

        const offsetHeight = this.$refs.lessMoreTextP.offsetHeight
        const lines = Math.round(offsetHeight / lineHeight)

        this.viewLessMore = lines >= 7
      },
    },

    mounted() {
      if (process.browser) {
        this.viewLessMoreButton()
      }
    },
  }
</script>

<style lang="scss" scoped>
  .less-more-text {
    p,
    .btn.btn-link {
      color: #8a8a8a;
      font-size: 0.9375rem;
      letter-spacing: 0;
      line-height: 1.4;
    }

    p {
      margin: 0;
    }

    .btn.btn-link {
      font-weight: 600;
      padding: 0;
      border: none;
      text-decoration: none;
      margin-top: 10px;

      &,
      &:hover,
      &:active,
      &:focus {
        outline: none;
        box-shadow: none;
      }
    }

    &.collapsed {
      p {
        display: -webkit-box;
        -webkit-line-clamp: 7;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
</style>
